const apiBaseUrl = process.env.VUE_APP_BASE_API || ''

function getTeacherResult(response) {
  if (response && response.result) {
    return response.result
  }

  if (response && response.data && response.data.result) {
    return response.data.result
  }

  return response || {}
}

export function extractTeacherRows(response) {
  const result = getTeacherResult(response)

  if (Array.isArray(result.records)) {
    return result.records
  }

  if (Array.isArray(result.list)) {
    return result.list
  }

  if (Array.isArray(result)) {
    return result
  }

  return []
}

export function extractTeacherTotal(response) {
  const result = getTeacherResult(response)
  const total = Number(result.total || result.count || 0)

  return Number.isFinite(total) ? total : 0
}

export function resolveTeacherImage(url) {
  if (!url) {
    return ''
  }

  if (/^(https?:)?\/\//.test(url) || /^(data|blob):/.test(url)) {
    return url
  }

  const base = apiBaseUrl.replace(/\/$/, '')
  const path = url.charAt(0) === '/' ? url : `/${url}`

  return base ? `${base}${path}` : path
}

export function formatTeacherCard(item, index) {
  const image = item.profile || item.avatar || item.image || item.photo

  return {
    id: item.id || `teacher-${index}`,
    name: item.name || item.teacherName || '教师',
    info: item.info || item.introduction || item.description || '',
    image: resolveTeacherImage(image)
  }
}
